"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadImage = exports.fileToDataURL = void 0;
function fileToDataURL(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            resolve(reader.result);
        });
        reader.addEventListener('error', error => {
            reject(error);
        });
        reader.readAsDataURL(file);
    });
}
exports.fileToDataURL = fileToDataURL;
function loadImage(src) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            resolve(img);
        };
        img.onerror = err => {
            // The image couldn't be loaded.
            reject(err);
        };
        img.src = src;
    });
}
exports.loadImage = loadImage;
//# sourceMappingURL=Utils.js.map